import $ from 'jquery'

(function () {
  const collapseTextHeight = 250
  const $textBlock = $('.toggle-text')
  const $collapseButton = $('.btn-toggleText');

  if ($textBlock.height() >= collapseTextHeight + 50) {
    $textBlock.height(collapseTextHeight)
    $collapseButton.on('click', function () {
      const expandTextHeight = $textBlock.children('.expand-text').height()

      if ($textBlock.hasClass('collapsed')) {
        $textBlock.removeClass('collapsed').animate({
          height: expandTextHeight,
        }, 400, function () {
          $(this).removeAttr('style')
        })
      } else {
        $textBlock.addClass('collapsed').animate({
          height: collapseTextHeight,
        })
      }
    })
  } else {
    $textBlock.removeClass('collapsed');
    $collapseButton.hide();
  }
})()
